// A quiet "relationship map" motif: a central show node connected to the
// categories of people worth building around. Pure SVG, no imagery — uses
// design tokens via Tailwind fill-/stroke- utilities so it themes correctly.
const NODES = [
  { x: 70, y: 60, label: "Future clients" },
  { x: 330, y: 70, label: "Referral partners" },
  { x: 40, y: 210, label: "Collaborators" },
  { x: 350, y: 220, label: "Industry peers" },
  { x: 200, y: 300, label: "Credibility partners" },
]

const CENTER = { x: 200, y: 165 }

export function RelationshipMap() {
  return (
    <svg
      viewBox="0 0 400 340"
      className="h-auto w-full text-hairline"
      role="img"
      aria-label="A relationship map connecting your show to future clients, referral partners, collaborators, industry peers, and credibility partners."
    >
      {NODES.map((n) => (
        <line
          key={`l-${n.label}`}
          x1={CENTER.x}
          y1={CENTER.y}
          x2={n.x}
          y2={n.y}
          stroke="currentColor"
          strokeWidth={1.5}
          strokeDasharray="3 5"
        />
      ))}

      {NODES.map((n) => (
        <g key={`n-${n.label}`}>
          <circle cx={n.x} cy={n.y} r={6} className="fill-accent" />
          <text
            x={n.x}
            y={n.y - 12}
            textAnchor="middle"
            className="fill-ink-muted"
            style={{ fontSize: 11 }}
          >
            {n.label}
          </text>
        </g>
      ))}

      <circle cx={CENTER.x} cy={CENTER.y} r={40} className="fill-accent-faded" />
      <circle
        cx={CENTER.x}
        cy={CENTER.y}
        r={40}
        className="fill-none stroke-accent"
        strokeWidth={1.5}
      />
      <text
        x={CENTER.x}
        y={CENTER.y - 2}
        textAnchor="middle"
        className="fill-ink-display"
        style={{ fontSize: 12, fontWeight: 600 }}
      >
        Your
      </text>
      <text
        x={CENTER.x}
        y={CENTER.y + 14}
        textAnchor="middle"
        className="fill-ink-display"
        style={{ fontSize: 12, fontWeight: 600 }}
      >
        show
      </text>
    </svg>
  )
}
